import { render, staticRenderFns } from "./StandList.vue?vue&type=template&id=063ccc11&scoped=true"
import script from "./StandList.vue?vue&type=script&lang=js"
export * from "./StandList.vue?vue&type=script&lang=js"
import style0 from "./StandList.vue?vue&type=style&index=0&id=063ccc11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ccc11",
  null
  
)

export default component.exports